// extracted by mini-css-extract-plugin
module.exports = {"bar":"bar-module--bar--17QsN","rehabilitarteLogo":"bar-module--rehabilitarteLogo--1Qow7"};